<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="产品编码" prop="productCode">
            <el-input v-model.trim="searchForm.productCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="产品名称" prop="productName">
            <el-input v-model.trim="searchForm.productName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="更新人" prop="updatedBy">
            <el-input v-model.trim="searchForm.updatedBy" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="更新时间" prop="updatedDateQuery">
            <el-date-picker
              v-model="searchForm.updatedDateQuery"
              unlink-panels
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportImport">导入</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            {{ scope.row[item.columnName] | cellValFormat }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="140">
          <template slot-scope="{ row }">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-button type="text" @click="record(row)">调整记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- 编辑 -->
    <edit-dialog :visible.sync="isShowEdit" v-if="isShowEdit" :rowData="rowData" @success="onSearch" />
    <!-- 调整记录 -->
    <record-details :visible.sync="isShowDetails" v-if="isShowDetails" :rowData="rowData" @success="onSearch" />
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin';
import axios from '@/utils/axiosInstance';
import editDialog from './components/edit.vue';
import recordDetails from './components/recordDetails.vue';
import { downloadFile } from '@/utils';
import moment from 'moment';
export default {
  name: 'ProductPriceSerach',
  mixins: [tableMixin, pagePathMixin],
  components: {
    editDialog,
    recordDetails
  },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: 'productWholePriceInfo',
      columnData: [],
      loading: false,
      searchForm: {
        productCode: '',
        productName: '',
        updatedBy: '',
        updatedDateQuery: [],
      },
      exportData: {},
      rowData: {},
      searchCollapse: false,
      isShowEdit: false,
      isShowDetails: false,
      queryCriteria: [],
      spuCategoryList: [],
      goodsLocationList: [],
      productTypeList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  computed: {},
  methods: {
    columns() {
      this.loading = true;
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then((res) => {
        this.columnData = res.data.sysColumns;
        this.init();
      });
    },
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: 'productCode', //产品编码
          val: this.searchForm.productCode ? this.searchForm.productCode.split(' ') : [],
          op: 'in',
        },
        {
          attributeName: 'productName', //产品名称
          val: this.searchForm.productName ? this.searchForm.productName : '',
          op: 'like',
        },
        {
          attributeName: 'updatedBy', //更新人
          val: [this.searchForm.updatedBy ? this.searchForm.updatedBy : ''],
          op: 'in',
        },
        {
          attributeName: 'updatedDateQuery', //更新时间
          val: this.searchForm.updatedDateQuery && this.searchForm.updatedDateQuery.length ? this.searchForm.updatedDateQuery : [],
          op: 'range',
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: '',
        orderType: '',
        hasCount: 'Y',
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            if (!type) {
              this.tableReload = false;
              this.$nextTick((_) => {
                this.tableReload = true;
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    edit(row) {
      this.rowData = {...row}
      this.isShowEdit = true
    },

    record(row) {
      this.rowData = {...row}
      this.isShowDetails = true
    },

    exportImport() {
      this.openSubPage({
        path: "/productPriceSerachImport",
        query: {
          fileName: "产品完整价格查询导入.xlsx",
          appCode: "ec-pc-new",
        },
      });
    },

    // 导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        taskDTO: {
          appCode: 'ec-pc-new',
          paramMap: {
            ...this.searchFormData,
          },
          reportName: this.reportName,
        },
        columnDTOs: [],
      };
      params.columnDTOs = this.columnData
        .map((item) => {
          return {
            columnName: item.displayName,
            fieldName: item.columnName,
            fieldType: 'string',
            columnFormat: null,
          };
        })
        .filter((v) => v.columnName != '图片'); // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== '图片');
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    this.columns();
  },
};
</script>

<style lang="stylus" scoped></style>
